<template>
  <div class="container">
    <div class="bg-wrap">
      <img src="../assets/reliableHome.jpg" class="bg-img" alt="">
    </div>

    <div class="content-wrap">
      <!-- 公告位置 -->
      <div class="notice-box">
         <div style="font-size:22px;font-weight:bold;color:#333;text-align:center">AI财印识人</div>
       </div>

      <div class="form-card">
        <van-form>
          <van-field
            v-model="name"
            label="名称"
            placeholder="请输入名称"
            style="margin:10px 0px"
          />
          <van-field
            v-model="prompt"
            type="textarea"
            label="提示词"
            placeholder="请输入提示词，例如：这个是这几天的聊天，她对我的态度是什么样的？"
            rows="3"
            autosize
            style="margin:10px 0px"
          />
          <div class="upload-section">
            <div class="upload-label">上传聊天截图</div>
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="5"
              :max-size="5 * 1024 * 1024"
              :after-read="afterRead"
              @oversize="onOversize"
              :before-delete="beforeDelete"
            />
            <div class="upload-tip">最多上传5张图片，每张不超过5M</div>
             <div class="notice-tip">
               <div class="notice-tip-title">购买前请阅读：</div>
               <div class="notice-tip-item">本产品旨在通过分析聊天记录，帮助用户理解对方自己的评价和态度。</div>
               <div class="notice-tip-item">1. 本产品是通过云端大模型调用自有skill实现运行。不排除某些情况下，显示结果不尽如人意，请包涵。</div>
               <div class="notice-tip-item">2. 聊天记录最好通过截图上传，可以传长截图，但是不要太长，不支持超过5M的截图。</div>
               <div class="notice-tip-item">3. 第一次传聊天截图提问是收费的，在同一个聊天窗口下，还有4次免费提问机会，但是尽量第一次就问清楚。第一次的提问质量决定了后续的回答质量。</div>
               <div class="notice-tip-item">4. 生成内容需要时间，生成时可以关闭窗口离开，在购买列表中获取新的生成内容。</div>
               <div class="notice-tip-item">5. 名称填写一定要具有辨识度，聊天记录图片不会长时间保存。</div>
             </div>
            </div>
        </van-form>
      </div>

      <div class="row-center" style="margin: 20px 0px">
        <van-button :loading="loading" loading-text="请求中..." :disabled="!canSubmit" class="button1Style" block type="info" native-type="submit" @click="onSubmit">
          开始分析
        </van-button>
        <van-button class="button2Style ml20" block type="info" @click="gotoList">
          查看记录
        </van-button>
      </div>

       <div style="text-align:center;color:#666;margin-top:20px">
        <img src="../assets/kefu.jpg" style="width:30%" alt="">
        <div style="font-size:14px;margin:10px;padding-bottom:20px">系统问题反馈请长按二维码，添加微信。</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { postAction, getAction } from '@/api/manage'
import wx from 'weixin-jsapi'
export default {
  name: 'ChatSubmit',
  data() {
    return {
      name: '',
      prompt: '',
      fileList: [],
      imageList: [],
      loading: false,
      pay: '0',
      userInfo: {},
    }
  },
  computed: {
    userinfoLove() {
      return this.$store.getters.getUserinfoLove || {}
    },
    openid() {
      return this.userinfoLove.jsopenid
    },
    unionid() {
      return this.userinfoLove.unionid
    },
    headimg() {
      return this.userinfoLove.image
    },
    nickname() {
      return this.userinfoLove.nickname
    },
    code() {
      return this.$route.query.code ? this.$route.query.code : ''
    },
    canSubmit() {
      // 必须至少有一张图片，且所有图片都上传完成
      if (this.fileList.length === 0) return false
      return !this.fileList.some(f => f.status === 'uploading')
    },
  },
  mounted() {
    // 本地调试：自动注入 mock 用户数据
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.$store.commit('setUserInfoLove', {
        unionid: 'oni4R6b8pwMrPWp0DoctYi4-Wx4M',
        jsopenid: 'mock_openid_67890',
        nickname: '测试用户',
        image: ''
      })
      return
    }
    if (!this.unionid) {
      if (!this.code) {
        var url = encodeURIComponent(window.location.protocol + '//' + window.location.hostname + '/chatSubmit')
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
        this.getJsLogin()
      }
    }
  },
  methods: {
    getJsLogin() {
      const url = '/xcxlove/double/jslogin'
      postAction(url, { code: this.code }).then(res => {
        if (res.data.code == 200 || res.data.code == 400) {
          this.userInfo = res.data.msg
          this.$store.commit('setUserInfoLove', this.userInfo)
        }
      })
    },
      onOversize() {
        Toast.fail('图片大小不能超过5M')
      },
      afterRead(file) {
      // 支持多选时，file可能是数组
      const files = Array.isArray(file) ? file : [file]
      files.forEach(item => {
        item.status = 'uploading'
        item.message = '上传中...'
        let formData = new FormData()
        // 后端字段名为 pic，接口为 /pic/chat/upload，返回 filename 即文件名
         formData.append('pic', item.file)
         const url = '/pic/chat/upload'
         postAction(url, formData).then(res => {
           if (res.data.code == 200) {
             item.status = 'done'
             item.message = '上传完成'
             const fileName = res.data.msg
             item.url = fileName
             this.imageList.push(fileName)
           } else {
             item.status = 'failed'
             item.message = '上传失败'
             Toast.fail(res.data.msg || '上传失败')
           }
        }).catch(() => {
          item.status = 'failed'
          item.message = '上传失败'
        })
      })
    },
    beforeDelete(file, detail) {
      // 同步删除imageList中对应的文件名
      const fileName = this.getFileName(file.url)
      const idx = this.imageList.indexOf(fileName)
      if (idx > -1) {
        this.imageList.splice(idx, 1)
      }
      return true
    },
    getFileName(url) {
      // 从完整URL或路径中提取文件名
      if (!url) return ''
      return url.substring(url.lastIndexOf('/') + 1)
    },
    gotoList() {
      this.$router.push({ path: '/chatList' })
    },
    onSubmit() {
      if (!this.name) {
        Toast.fail('请输入名称')
        return
      }
      if (!this.prompt) {
        Toast.fail('请输入提示词')
        return
      }
      if (this.imageList.length === 0) {
        Toast.fail('请上传至少一张图片')
        return
      }
      // 校验是否所有图片都上传完成
      const uploading = this.fileList.some(f => f.status === 'uploading')
      if (uploading) {
        Toast.fail('图片正在上传中，请稍候')
        return
      }

      // 先调起微信支付
      Toast.loading({
        message: '正在评定中，请稍后...',
        forbidClick: true,
        duration: 0,
      })
      setTimeout(() => {
        Toast.clear()
        this.wxPay()
      }, 2000)
    },
    wxPay() {
      const url = '/chat/wxpay'
      var that = this
      getAction(url, {
        unionid: this.unionid,
        openid: this.openid
      }).then(res => {
        if (res.data.code === 200) {
          const result = res.data.msg.result
          wx.config({
            debug: false,
            appId: result.appId,
            timestamp: result.timeStamp,
            nonceStr: result.nonceStr,
            signature: result.paySign,
            jsApiList: ['checkJsApi', 'chooseWXPay']
          })
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ['chooseWXPay'],
              success: function () {
                wx.chooseWXPay({
                  timestamp: result.timeStamp,
                  nonceStr: result.nonceStr,
                  package: result.package,
                  signType: result.signType,
                  paySign: result.paySign,
                  success: function () {
                    that.pay = '1'
                    that.analyze()
                  },
                  fail: function () {
                    Toast.fail('支付失败')
                  }
                })
              },
              fail: function (res) {
                console.log(res)
              }
            })
          })
          wx.error(err => {
            console.log(err)
          })
        } else {
          Toast.fail(res.data.msg)
        }
      }).catch(() => {
        Toast.fail('请求失败')
      })
    },
    analyze() {
      this.loading = true
      const url = '/chat/analyze'
      postAction(url, {
        unionid: this.unionid,
        pay: this.pay,
        name: this.name,
        prompt: this.prompt,
        image_list: this.imageList
      }).then(res => {
        if (res.data.code == 200) {
          Toast.success(res.data.msg || '提交成功')
          this.$router.push({ path: '/chatList' })
        } else {
          Toast.fail(res.data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
}
.bg-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 0;
}
.bg-img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}
.content-wrap {
  position: relative;
  z-index: 1;
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  padding-top: 30vh;
}
.notice-box {
  width: 100%;
  min-height: 40px;
  margin-bottom: 20px;
  border-radius: 0px 20px 20px 20px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px 16px;
}
.form-card {
  width: 100%;
  margin: 20px auto;
  padding: 20px 16px;
  border-radius: 0px 30px 30px 30px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
}
.upload-section {
  margin: 10px 0px;
}
.upload-label {
  text-align: left;
  color: #333;
  font-size: 14px;
  margin-bottom: 8px;
}
.upload-tip {
  text-align: left;
  color: #999;
  font-size: 12px;
  margin-top: 6px;
}
.notice-tip {
  background: rgba(255, 245, 240, 0.9);
  border-left: 3px solid #ff6b81;
  border-radius: 6px;
  padding: 10px 12px;
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.8;
  color: #333;
  text-align: left;
}
.notice-tip-title {
  font-weight: bold;
  color: #ff4757;
  margin-bottom: 6px;
  font-size: 14px;
}
.notice-tip-item {
  margin-bottom: 4px;
}
::v-deep .van-cell {
  background: rgb(233, 230, 230);
  border-radius: 10px;
}
::v-deep .van-field__label {
  color: #333;
}
::v-deep input {
  color: #333;
  background-color: transparent;
}
::v-deep textarea {
  color: #333;
  background-color: transparent;
}
.button1Style {
  background: rgb(255, 174, 191);
  border: 1px solid rgb(242, 197, 204);
  font-size: 19px;
  width: 150px;
  padding: 0px 5px;
  border-radius: 6px;
}
.button2Style {
  background: rgb(182, 182, 182);
  border: 1px solid rgb(182, 182, 182);
  font-size: 20px;
  width: 150px;
  border-radius: 6px;
}
</style>
